import { Level, LevelAttribute } from "@src/redux/index";
import { Button, Col, Form, Input, Modal, Row, Tooltip } from "antd";
import React, { memo, useEffect, useState } from "react";
import LevelAttributesForm from "./LevelAttributesForm";
import { useTranslation } from "react-i18next";
import LevelAttributesDetails from "./level-attributes/LevelAttributesDetails";
import { getUuid } from "@src/helpers/functions";
import LevelForm from "./LevelForm";
import { IoMdOptions } from "react-icons/io";
import { RiUserSettingsLine } from "react-icons/ri";
import { RiUserSettingsFill } from "react-icons/ri";
import { DeleteOutlined } from "@ant-design/icons";
type Props = {
  level: Level;
  setLevelList: React.Dispatch<React.SetStateAction<Level[]>>;
  levelList: Level[];
  levelIndex: number;
};

const LevelDetails = (props: Props) => {
  const [attributeModal, setAttributeModal] = useState<boolean>(false);
  const [levelFormModal, setLevelFormModal] = useState<boolean>(false);
  const [levelDeleteModal, setLevelDeleteModal] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [viewAttributeDetailsModal, setViewAttributeDetailsModal] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const {
    level,
    levelList,
    setLevelList,
    level: getLevel,
    levelIndex,
  } = props;
  const [form] = Form.useForm();
  const [levelForm] = Form.useForm();
  const handleAdd = () => {
    setAttributeModal(true);
  };
  const addAttributeToLevel = (
    parentLevelId: string,
    newAttribute: LevelAttribute
  ) => {
    const updateLevelList = (levels: Level[]): Level[] => {
      return levels.map((level, index) => {
        if (level.id === getLevel.id) {
          const updatedLevel = {
            ...level,
            levelAttributeList: [
              ...(level.levelAttributeList || []),
              { ...newAttribute, sortOrder: index + 1 },
            ],
          };
          return updatedLevel;
        }
        return level;
      });
    };

    setLevelList((prev: Level[]) => {
      const updatedLevels = updateLevelList(prev);
      return updatedLevels;
    });
  };
  const handleConfirmRemove = () => {
    setLevelList((prev: Level[]) => {
      const removeLevels = removeLevelById(level.id || "", prev);

      return removeLevels;
    });
    handleClose();
  };
  const handleFinish = (values: any) => {
    addAttributeToLevel(level?.parentLevelId || level.id || "", {
      id: getUuid(),
      fieldType: "select",
      ...values,
    });
    handleClose();
  };

  const updateLevelByParentId = (
    parentLevelId: string,
    updatedData: Partial<Level>,
    allLevelList: Level[]
  ): Level[] => {
    return allLevelList.map((level) => {
      if (level.id === getLevel.id) {
        return {
          ...level,
          ...updatedData,
        };
      }

      return level;
    });
  };

  const handleClose = () => {
    setAttributeModal(false);
    setLevelFormModal(false);
    setViewAttributeDetailsModal(false);
    form.resetFields();
    levelForm.resetFields();
    setLevelDeleteModal(false);
  };
  const handleViewAttribute = () => {
    setViewAttributeDetailsModal(true);
  };
  const handleDeleteLevel = () => {
    setLevelDeleteModal(true);
  };

  const handleLevelUpdate = (values: any) => {
    setLevelList((prev: Level[]) => {
      const updatedLevels = updateLevelByParentId(
        level.parentLevelId || "",
        { ...values, fieldType: "select" },
        prev
      );
      return updatedLevels;
    });
    handleClose();
  };

  const removeLevelById = (
    levelId: string,
    allLevelList: Level[]
  ): Level[] => {
    return allLevelList
      .map((level) => {
        const updatedChildLevels = level.childLevelList
          ? removeLevelById(levelId, level.childLevelList)
          : [];

        if (level.id === levelId) {
          return updatedChildLevels;
        }

        return {
          ...level,
          childLevelList: updatedChildLevels,
        };
      })
      .flat();
  };

  const handleChangeInput = (value: string) => {
    setInputValue(value);
  };

  useEffect(() => {
    if (level.name && inputValue !== level.name) {
      setInputValue(level.name);
    }
  }, [level.name]);

  const handleBlur = () => {
    setLevelList((prev: Level[]) =>
      prev.map((list: Level) => {
        if (list?.id === level?.id && list.name !== inputValue) {
          return {
            ...list,
            name: inputValue,
          };
        }
        return list;
      })
    );
  };

  const handleChangeCheckBox = (value: boolean) => {
    setLevelList((prev: Level[]) =>
      prev.map((list: Level, idx: number) => {
        if (value) {
          if (idx <= levelIndex) {
            return {
              ...list,
              allowKitAssign: true,
            };
          }
          return {
            ...list,
            allowKitAssign: false,
          };
        } else {
          return {
            ...list,
            allowKitAssign: false,
          };
        }
      })
    );
  };
  const handleAssignOperator = (value: boolean) => {
    handleChangeCheckBox(true);
    setLevelList((prev: Level[]) =>
      prev.map((list: Level, idx: number) => {
        if (idx === levelIndex) {
          return {
            ...list,
            allowOperatorLogin: true,
          };
        } else
          return {
            ...list,
            allowOperatorLogin: false,
          };
      })
    );
  };
  const handleUnAssignOperator = (value?: boolean) => {
    handleChangeCheckBox(false);
    setLevelList((prev: Level[]) =>
      prev.map((list: Level, idx: number) => {
        if (idx === levelIndex) {
          return {
            ...list,
            allowOperatorLogin: false,
          };
        }
        return {
          ...list,
        };
      })
    );
  };

  return (
    <>
      {/* <div className="level-card-container">
        <div className="level-card-icon-container"> */}
      <Input
        value={inputValue}
        // style={{ width: "300px" }}
        onChange={(e: any) => handleChangeInput(e?.target?.value)}
        onBlur={handleBlur}
        className="level-name-input"
      />
      <div className="level-add-attribute">
        <Tooltip title={t("add_attributes")}>
          <IoMdOptions
            onClick={handleViewAttribute}
            className="level-card-icon"
            size={20}
          />
        </Tooltip>
      </div>

      {/* <Switch
        value={level.allowKitAssign}
        onChange={handle_change_check_box}
        key={level.id}
      /> */}
      {level.allowOperatorLogin ? (
        <RiUserSettingsFill
          size={20}
          onClick={() => handleUnAssignOperator(false)}
          key={level.id}
          color="#0e7bf6"
        />
      ) : (
        <RiUserSettingsLine
          size={20}
          onClick={() => handleAssignOperator(true)}
          key={level.id}
        />
      )}
      {levelIndex !== 0 ? (
        <div className="level-delete-action">
          <DeleteOutlined onClick={handleDeleteLevel} />
        </div>
      ) : (
        <div className="level-delete-action"></div>
      )}
      {/* </div>
      </div> */}
      <Modal
        open={attributeModal}
        footer={null}
        title={<span className="dynamic-modal">{"Add Attributes"}</span>}
        onCancel={handleClose}
      >
        <Form onFinish={handleFinish} layout="vertical" form={form}>
          <LevelAttributesForm />
          <Row justify="end" gutter={10}>
            <Col>
              <Button type="default" onClick={handleClose}>
                {t("close")}
              </Button>
            </Col>
            <Col>
              <Button htmlType="submit" type="primary">
                {t("submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={levelFormModal}
        onCancel={handleClose}
        title={<span className="dynamic-modal">{"Update Level"}</span>}
        footer={null}
      >
        <Form
          onFinish={handleLevelUpdate}
          layout="vertical"
          form={levelForm}
        >
          <LevelForm />
          <Row justify="end" gutter={10}>
            <Col>
              <Button type="default" onClick={handleClose}>
                {t("close")}
              </Button>
            </Col>
            <Col>
              <Button htmlType="submit" type="primary">
                {t("submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={viewAttributeDetailsModal}
        onCancel={handleClose}
        title={t("view_attributes")}
        footer={null}
      >
        <Row justify={"end"}>
          <Col>
            <Button onClick={handleAdd} type="primary">
              Add Attributes
            </Button>
          </Col>
        </Row>
        <LevelAttributesDetails
          levelAttributes={level.levelAttributeList || []}
          setLevelList={setLevelList}
          levelList={levelList}
          level={level}
        />
      </Modal>
      <Modal
        open={levelDeleteModal}
        title={t("level_delete_confirmation")}
        onCancel={handleClose}
        onOk={handleConfirmRemove}
      >
        {t("level_delete_content")} <b>{level.name}?</b>
      </Modal>
    </>
  );
};

export default memo(LevelDetails);
